const doc = [({"en":({"js":({"admin":({"invoices":({"edit":({"add_new_invoice":"Add new invoice", "edit_invoice":"Edit invoice", "the_invoice_was_saved":"The invoice was saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;